/* Die zwei eigenen Sortierungen: VANTIQ-Index und Verfügbarkeit.

   Shopify kann nach Metafeldern nicht sortieren. Der Browser muss die
   vollständige gefilterte Menge kennen, um sie zu ordnen — und zeigt danach
   wieder nur eine Seite.

   === Warum das hier zweimal lädt ===

   Die erste Fassung holte die ganze Menge als fertige Produktkarten:
   54 Seiten zu je 250 Reifen, 5'577 Bytes pro Karte, zusammen **79 MB** — um
   daraus 24 Karten anzuzeigen und 99,8 % wegzuwerfen. Gemessene 15 Sekunden,
   und zwar bei jedem Sortierwechsel, weil nichts gespeichert wurde.

   Jetzt in zwei Schritten:

     1. `?view=vantiq-keys`   handle, Index, Rang, Preis — 53 Bytes je Reifen
                              statt 5'577. Nur daraus wird sortiert.
     2. `?view=karte`         die 24 Karten der gezeigten Seite, einzeln und
                              parallel geholt.

   Geholte Karten bleiben im Speicher: Wer blättert, lädt nur, was er noch
   nicht gesehen hat.
*/
(function () {
  'use strict';

  var select = document.querySelector('[data-vantiq-sortierung]');
  var liste = document.querySelector('.st-liste-layout__inhalt .st-produkte');
  if (!liste) return;

  var status = document.querySelector('[data-vantiq-sortierstatus]');
  var url = new URL(window.location.href);
  var eigeneSortierung = url.searchParams.get('vantiq_sort') || '';

  /* Nur ein sichtbares Sortierfeld bekommt den Index als Standard. Eine
     ausdrueckliche native oder eigene Wahl bleibt unangetastet; „Alle Reifen"
     ohne Sortierfeld behaelt seine bestehende Segment-Priorisierung. Die URL
     muss den Standard tragen, damit Filter und Seitenwechsel ihn behalten. */
  if (select && !url.searchParams.has('sort_by') && !url.searchParams.has('vantiq_sort')) {
    eigeneSortierung = 'vantiq-index-absteigend';
    url.searchParams.set('vantiq_sort', eigeneSortierung);
    window.history.replaceState(window.history.state, '', url.toString());
  }
  if (!select && eigeneSortierung !== 'segment-prioritaet') return;
  var proSeite = Number(liste.dataset.proSeite || 24);
  var gesamt = Number(liste.dataset.gesamt || 0);

  function statusSetzen(text, sichtbar) {
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !sichtbar;
  }

  function filterSortierungErhalten() {
    if (!eigeneSortierung) return;

    /* Die Premium-Priorisierung gehört nur zum ungefilterten Einstieg
       „Alle Reifen". Sobald jemand einen Filter setzt, soll daraus weder eine
       unsichtbare Dauersortierung noch wieder eine Premium-Auswahl werden. */
    if (eigeneSortierung === 'segment-prioritaet') {
      document
        .querySelectorAll('.st-filter a[href], .st-aktivfilter__pille[href]')
        .forEach(function (link) {
          var ziel = new URL(link.href, window.location.origin);
          ziel.searchParams.delete('vantiq_sort');
          link.href = ziel.toString();
        });
      return;
    }

    var formular = document.querySelector('.st-filter');
    if (formular && !formular.querySelector('input[name="vantiq_sort"]')) {
      var feld = document.createElement('input');
      feld.type = 'hidden';
      feld.name = 'vantiq_sort';
      feld.value = eigeneSortierung;
      formular.appendChild(feld);
    }

    document
      .querySelectorAll('.st-filter a[href], .st-aktivfilter__pille[href]')
      .forEach(function (link) {
        var ziel = new URL(link.href, window.location.origin);
        ziel.searchParams.set('vantiq_sort', eigeneSortierung);
        link.href = ziel.toString();
      });
  }

  if (select) select.addEventListener('change', function () {
    var teile = select.value.split(':');
    var art = teile.shift();
    var wert = teile.join(':');
    var ziel = new URL(window.location.href);

    ziel.searchParams.delete('page');
    if (art === 'custom') {
      ziel.searchParams.delete('sort_by');
      ziel.searchParams.set('vantiq_sort', wert);
    } else {
      ziel.searchParams.delete('vantiq_sort');
      ziel.searchParams.set('sort_by', wert);
    }
    window.location.assign(ziel.toString());
  });

  if (!eigeneSortierung) return;
  if (select) {
    var option = Array.from(select.options).find(function (eintrag) {
      return eintrag.value === 'custom:' + eigeneSortierung;
    });
    if (!option && eigeneSortierung !== 'segment-prioritaet') return;
    if (option) option.selected = true;
  }
  filterSortierungErhalten();

  /* --------------------------------------------------------- Beschaffung */

  var kartenSpeicher = new Map();

  /* Die Schlüssel überleben den Sortierwechsel.

     Sie hängen vom FILTER ab, nicht von der Sortierung — wer von „Index
     absteigend" auf „Verfügbarkeit" wechselt, sieht dieselben Reifen in
     anderer Reihenfolge. Trotzdem wurde bisher jedes Mal alles neu geholt.

     Und billiger wird das Holen nicht: Der Browser lässt pro Host nur rund
     fünf Abrufe gleichzeitig zu. Gemessen 54 Seiten à 554 ms, parallel 6.3 s
     — das ist die Grenze des Browsers, nicht unsere.

     Also einmal je Filterstand in den Sitzungsspeicher. Der Schlüssel ist die
     Adresse ohne Sortierung, Seite und Ansicht; ändert der Kunde einen
     Filter, entsteht ein neuer Eintrag und der alte verfällt mit der
     Sitzung. */
  var SPEICHERFASSUNG = 'vantiq:sortierschluessel:v3:';

  function speicherSchluessel() {
    var z = new URL(window.location.href);
    ['sort_by', 'vantiq_sort', 'page', 'view'].forEach(function (n) {
      z.searchParams.delete(n);
    });
    z.searchParams.sort();
    return SPEICHERFASSUNG + z.pathname + z.search;
  }

  function ausSpeicher() {
    try {
      var roh = window.sessionStorage.getItem(speicherSchluessel());
      return roh ? JSON.parse(roh) : null;
    } catch (e) {
      return null;
    }
  }

  function inSpeicher(eintraege) {
    try {
      window.sessionStorage.setItem(speicherSchluessel(), JSON.stringify(eintraege));
    } catch (e) {
      /* Voller Speicher oder privater Modus — dann eben jedes Mal neu.
         Ein Abbruch wäre hier das Schlechtere: Die Sortierung funktioniert
         auch ohne Zwischenspeicher, nur langsamer. */
    }
  }

  function quelleUrl(ansicht, seite, segmente) {
    var ziel = new URL(window.location.href);
    ziel.searchParams.delete('vantiq_sort');
    /* Nur die Sonderreihenfolge „Alle Reifen – Premium zuerst" baut eigene
       Segmentmengen. Normale Sortierungen müssen den aktiven Segmentfilter
       unverändert behalten. */
    if (Array.isArray(segmente)) {
      ziel.searchParams.delete('filter.p.m.custom.segment');
      segmente.forEach(function (segment) {
        ziel.searchParams.append('filter.p.m.custom.segment', segment);
      });
    }
    ziel.searchParams.set('view', ansicht);
    if (seite) ziel.searchParams.set('page', String(seite));
    else ziel.searchParams.delete('page');

    /* Feste Sortierung beim Einsammeln — sonst fehlt ein Drittel der Reifen.
       -------------------------------------------------------------------
       Hier stand `delete('sort_by')`, die Schlüssel kamen also in Shopifys
       Standardreihenfolge. Auf `/search?q=tag:…` ist das die RELEVANZ, und
       die ist zwischen zwei Abrufen nicht stabil: Wer 54 Seiten
       hintereinander holt, bekommt Reifen mehrfach und andere gar nicht.

       Am 11.8.2026 über alle 54 Seiten von `tag:Sommerreifen` gemessen —
       13'266 Zeilen, davon verschieden:

           Standard (Relevanz)     8'896   →  4'370 Reifen fehlen  (33 %)
           sort_by=best-selling    9'292   →  3'974
           sort_by=title-ascending 9'965   →  3'301
           sort_by=price-ascending 13'167  →     99  (0,7 %)

       Für die Sortierung ist das kein Schönheitsfehler: Wer nach
       VANTIQ-Index ordnen liess, ordnete eine Menge, in der ein Drittel des
       Sortiments fehlte — und merkte nichts davon, weil die Liste vollständig
       aussah.

       Welche Reihenfolge der Server liefert, ist gleichgültig; sortiert wird
       ohnehin im Browser. Verlangt wird nur, dass sie sich zwischen den
       Seitenabrufen nicht ändert. Der Preis erfüllt das am besten — die
       verbleibenden 99 dürften Artikel sein, deren Preis während des Abrufs
       geschrieben wurde.

       Auf Kollektionsseiten war die Reihenfolge schon vorher stabil (gemessen
       0 Dubletten über 54 Seiten); dort schadet die feste Sortierung nicht. */
    ziel.searchParams.set('sort_by', 'price-ascending');
    return ziel.toString();
  }

  async function schluesselSeite(seite, segmente) {
    /* Ohne `Accept`-Kopf.

       Mit `Accept: text/plain` antwortet Shopify auf genau dieselbe Adresse
       mit **404** — die Route entscheidet nach dem Kopf, und eine
       Liquid-Vorlage gilt dort als HTML, auch wenn sie Text ausgibt. Gemessen:
       dieselbe URL, mit Kopf 404, ohne Kopf 200. Eine halbe Stunde gesucht. */
    var antwort = await fetch(quelleUrl('vantiq-keys', seite, segmente), {
      credentials: 'same-origin',
    });
    if (!antwort.ok) throw new Error('Schlüssel Seite ' + seite + ': HTTP ' + antwort.status);

    var text = await antwort.text();
    /* Auf JEDE Art von Zeilenende teilen, nicht nur auf CRLF.

       Die Suchansicht kam mit blossen Wagenrückläufen: Die Whitespace-Trims
       von Liquid fressen den Zeilenvorschub und lassen das CR stehen, wenn
       die Vorlage mit CRLF gespeichert ist. Der Parser sah damit genau EINE
       Zeile, verbrauchte sie als Seitenzahl — und die Liste blieb leer,
       während der Abruf mit 200 und 8'913 Zeichen antwortete. */
    var zeilen = text.trim().split(/[\r\n]+/);
    /* Die erste Zeile ist die Seitenzahl, danach ein Reifen je Zeile. */
    var seiten = Number(zeilen.shift()) || 1;
    var eintraege = [];
    zeilen.forEach(function (zeile) {
      var t = zeile.split('\t');
      if (t.length < 4 || !t[0].trim()) return;
      eintraege.push({
        handle: t[0].trim(),
        index: Number(t[1]),
        rang: Number(t[2]),
        preis: Number(t[3]),
      });
    });
    return { seiten: seiten, eintraege: eintraege };
  }

  async function alleSchluessel(segmente) {
    var erste = await schluesselSeite(1, segmente);
    var auftraege = [];
    for (var seite = 2; seite <= erste.seiten; seite += 1) {
      auftraege.push(schluesselSeite(seite, segmente));
    }
    var weitere = await Promise.all(auftraege);
    return erste.eintraege.concat(
      weitere.flatMap(function (ergebnis) {
        return ergebnis.eintraege;
      }),
    );
  }

  async function karteHolen(handle) {
    if (kartenSpeicher.has(handle)) return kartenSpeicher.get(handle);

    var produktWurzel = `${window.Shopify?.routes?.root || '/'}products/`.replace(/\/{2,}/g, '/');
    var antwort = await fetch(
      produktWurzel + encodeURIComponent(handle) + '?view=karte',
      { credentials: 'same-origin', headers: { Accept: 'text/html' } },
    );
    if (!antwort.ok) throw new Error('Karte ' + handle + ': HTTP ' + antwort.status);

    var doc = new DOMParser().parseFromString(await antwort.text(), 'text/html');
    var karte = doc.querySelector('.st-produkt');
    if (!karte) throw new Error('Karte ' + handle + ': kein Markup');
    kartenSpeicher.set(handle, karte);
    return karte;
  }

  /* ---------------------------------------------------------- Reihenfolge

     Verglichen werden schlichte Objekte, nicht mehr DOM-Knoten mit
     data-Attributen. Dieselbe Reihenfolge wie vorher, nur ohne den Umweg über
     13'267 gerenderte Karten. */
  function vergleichen(a, b) {
    var verfuegbarA = Number.isFinite(a.rang) ? a.rang : 2;
    var verfuegbarB = Number.isFinite(b.rang) ? b.rang : 2;
    var indexA = Number.isFinite(a.index) ? a.index : -1;
    var indexB = Number.isFinite(b.index) ? b.index : -1;
    var preisA = Number.isFinite(a.preis) ? a.preis : Number.MAX_SAFE_INTEGER;
    var preisB = Number.isFinite(b.preis) ? b.preis : Number.MAX_SAFE_INTEGER;

    if (eigeneSortierung === 'segment-prioritaet') {
      var segmentA = Number.isFinite(a.segmentRang) ? a.segmentRang : 1;
      var segmentB = Number.isFinite(b.segmentRang) ? b.segmentRang : 1;
      if (segmentA !== segmentB) return segmentA - segmentB;
      if (verfuegbarA !== verfuegbarB) return verfuegbarA - verfuegbarB;
      if (indexA !== indexB) return indexB - indexA;
      if (preisA !== preisB) return preisA - preisB;
      return a.handle.localeCompare(b.handle, 'de-CH', { sensitivity: 'base' });
    }

    /* Nach der Verfügbarkeit kommt der Preis, nicht der Index.

       Die Verfügbarkeit kennt nur drei Stufen — ab Lager, ab Aussenlager,
       nicht bestellbar. Sie ordnet also nicht die Liste, sondern teilt sie in
       Blöcke; die eigentliche Reihenfolge macht der zweite Schlüssel. Dort
       stand der VANTIQ-Index, und im Block „ab Aussenlager" ergab das
       Index 84 vor 74 — also CHF 128.90 vor CHF 77.90. Wer nach
       Verfügbarkeit sortiert, hat damit die Lieferzeit gewählt und
       entscheidet innerhalb des Blocks über den Preis; eine Liste, in der
       die Preise springen, hilft ihm dabei nicht.

       Der Index bleibt als dritte Stufe: Bei zwei gleich teuren Reifen im
       selben Block steht der bessere oben. */
    if (eigeneSortierung === 'verfuegbarkeit-absteigend') {
      if (verfuegbarA !== verfuegbarB) return verfuegbarA - verfuegbarB;
      if (preisA !== preisB) return preisA - preisB;
      if (indexA !== indexB) return indexB - indexA;
    } else if (eigeneSortierung === 'verfuegbarkeit-aufsteigend') {
      if (verfuegbarA !== verfuegbarB) return verfuegbarB - verfuegbarA;
      if (preisA !== preisB) return preisA - preisB;
      if (indexA !== indexB) return indexB - indexA;
    } else if (eigeneSortierung === 'vantiq-index-aufsteigend') {
      if (indexA !== indexB) return indexA - indexB;
      if (verfuegbarA !== verfuegbarB) return verfuegbarA - verfuegbarB;
    } else {
      if (indexA !== indexB) return indexB - indexA;
      if (verfuegbarA !== verfuegbarB) return verfuegbarA - verfuegbarB;
    }
    if (preisA !== preisB) return preisA - preisB;
    /* Der Handle als letzte Stufe: stabil und eindeutig, damit zwei
       gleichwertige Reifen nicht bei jedem Aufruf die Plätze tauschen. */
    return a.handle.localeCompare(b.handle, 'de-CH', { sensitivity: 'base' });
  }

  /* ------------------------------------------------------------ Anzeigen */

  async function seiteZeigen(schluessel, seite) {
    var seiten = Math.max(1, Math.ceil(schluessel.length / proSeite));
    var aktuell = Math.min(Math.max(1, seite), seiten);
    var start = (aktuell - 1) * proSeite;
    var ausschnitt = schluessel.slice(start, start + proSeite);

    liste.setAttribute('aria-busy', 'true');
    var karten = await Promise.all(
      ausschnitt.map(function (e) {
        return karteHolen(e.handle);
      }),
    );
    liste.replaceChildren.apply(liste, karten);
    liste.removeAttribute('aria-busy');

    blaetternBauen(schluessel, aktuell, seiten);
    document.dispatchEvent(new CustomEvent('vantiq:liste-getauscht'));
  }

  function blaetternBauen(schluessel, aktuell, seiten) {
    var nav = document.querySelector('.st-liste-layout__inhalt .st-blaettern');
    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'st-blaettern';
      nav.setAttribute('aria-label', window.vantiqText('collection_sort.pages'));
      liste.insertAdjacentElement('afterend', nav);
    }
    nav.replaceChildren();

    var zurueck = document.createElement('button');
    zurueck.type = 'button';
    zurueck.textContent = window.vantiqText('common.back');
    zurueck.disabled = aktuell <= 1;

    var anzeige = document.createElement('span');
    anzeige.className = 'zahl';
    anzeige.textContent = window.vantiqText('collection_sort.page_of', {
      current: aktuell,
      total: seiten,
    });

    var weiter = document.createElement('button');
    weiter.type = 'button';
    weiter.textContent = window.vantiqText('collection_sort.next');
    weiter.disabled = aktuell >= seiten;

    function wechseln(neueSeite) {
      var neueUrl = new URL(window.location.href);
      neueUrl.searchParams.set('page', String(neueSeite));
      window.history.pushState({}, '', neueUrl.toString());
      seiteZeigen(schluessel, neueSeite);
      (document.getElementById('sortiment-205') || document.querySelector('.st-liste-layout__inhalt')).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }

    zurueck.addEventListener('click', function () {
      wechseln(aktuell - 1);
    });
    weiter.addEventListener('click', function () {
      wechseln(aktuell + 1);
    });

    nav.append(zurueck, anzeige, weiter);
  }

  async function starten() {
    liste.setAttribute('aria-busy', 'true');
    statusSetzen(window.vantiqText('collection_sort.preparing'), true);

    try {
      var schluessel = ausSpeicher();
      if (!schluessel) {
        if (eigeneSortierung === 'segment-prioritaet') {
          /* Zwei getrennte Mengen umgehen Shopifys 25'000er-Grenze und
             ergeben trotzdem eine einzige vollständige Liste. Mehrere Werte
             desselben Listenfilters werden von Shopify mit ODER verknüpft. */
          var gruppen = await Promise.all([
            alleSchluessel(['Premium']),
            alleSchluessel(['Quality', 'Qualität', 'Budget']),
          ]);
          gruppen[0].forEach(function (eintrag) { eintrag.segmentRang = 0; });
          gruppen[1].forEach(function (eintrag) { eintrag.segmentRang = 1; });
          schluessel = gruppen[0].concat(gruppen[1]);

          /* Falls ein Altprodukt noch kein Segment trägt, darf es deswegen
             nicht aus „Alle Reifen" verschwinden. Die normale Menge liefert
             bis zur Shopify-Grenze Ergänzungen; Dubletten werden entfernt. */
          if (gesamt && schluessel.length < gesamt) {
            var ergaenzung = await alleSchluessel([]);
            ergaenzung.forEach(function (eintrag) { eintrag.segmentRang = 1; });
            schluessel = schluessel.concat(ergaenzung);
          }
          var gesehen = new Set();
          schluessel = schluessel.filter(function (eintrag) {
            if (gesehen.has(eintrag.handle)) return false;
            gesehen.add(eintrag.handle);
            return true;
          });
        } else {
          schluessel = await alleSchluessel();
        }
        inSpeicher(schluessel);
      }
      /* Frisch sortieren, auch aus dem Speicher: Die Reihenfolge hängt an
         `eigeneSortierung`, gespeichert ist nur die Menge. */
      schluessel = schluessel.slice().sort(vergleichen);

      /* Shopify deckelt `paginate.items` bei 25'001, obwohl die getrennten
         Segmentmengen mehr Reifen enthalten können. Nach dem Zusammenführen
         kennen wir die wirkliche Zahl und zeigen sie auch im Listenkopf. */
      var kennzahl = document.querySelector('.st-liste-kennzahl .zahl');
      if (kennzahl && eigeneSortierung === 'segment-prioritaet') {
        kennzahl.textContent = String(schluessel.length);
      }

      await seiteZeigen(schluessel, Number(url.searchParams.get('page') || 1));
      statusSetzen('', false);
    } catch (fehler) {
      console.error('VANTIQ-Sortierung:', fehler);
      statusSetzen(
        window.vantiqText('collection_sort.failed'),
        true,
      );
    } finally {
      liste.removeAttribute('aria-busy');
    }
  }

  starten();
})();
